
import { defineComponent, computed, PropType } from 'vue'
import { Campaign } from '@/types'
import { Selection, Payment } from '@/types/order'
import { Shipping } from '@/lib/shipping'
import { formatPrice } from '@/lib/formatters'

export default defineComponent({
  props: {
    campaign: {
      type: Object as PropType<Campaign>,
      required: true
    },
    selections: {
      type: Array as PropType<Selection[]>,
      required: true
    },
    payment: {
      type: Object as PropType<Payment>,
      required: true
    }
  },
  setup (props) {
    const productPrice = computed(() => {
      const prices = props.selections.map(s => {
        const variant = props.campaign.variants.find(v => v.id === s.variantId)
        return variant ? variant.priceWithTax * s.quantity : 0
      })

      return prices.reduce((a, b) => a + b)
    })

    const taxPrice = computed(() => Math.floor(productPrice.value / 10))
    const paymentFee = computed(() => props.payment.method === 'deferred' ? 330 : 0)

    const shippingCost = computed(() => {
      const quantity = props.selections.reduce((a, b) => a + b.quantity, 0)
      return Shipping.findShippingCost(props.campaign.item.name, quantity)
    })

    const totalPrice = computed(() => {
      return props.payment.method === 'sampleOrder' ? 0 : (productPrice.value + paymentFee.value + shippingCost.value)
    })

    return { productPrice, taxPrice, paymentFee, shippingCost, totalPrice, formatPrice }
  }
})
